import React from "react";

import { TabList as ATabList, TabListProps } from "@atlaskit/tabs";

export const TabList: React.FC<TabListProps> = (props) => <ATabList {...props} />;

export type { TabListProps };
